export default "__VITE_ASSET__zSvGzz2c__"